import {
  Box, Flex, Text, Title
} from '@huspy/briks-web';
import React from 'react';

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  asideTitleContent?: React.ReactNode;
};

const MainContentPageWrapper = ({
  title, subtitle, children, asideTitleContent,
}: Props) => (
  <Flex direction='column' bg='white'>
    <Flex pb='6' justifyContent='flex-start'>
      <Box flex={ 1 }>
        <Title fontSize='h6' weight='medium' letterSpacing='-2' data-test='page-title'>{title}</Title>
        {subtitle && (
          <Text
            color='text-tertiary'
            letterSpacing='-0.8'
            fontSize='md'
          >
            {subtitle}
          </Text>
        )}
      </Box>
      {asideTitleContent}
    </Flex>

    <Flex direction='column'>
      {children}
    </Flex>
  </Flex>
);

export default MainContentPageWrapper;
